import {FirefoxBrowser} from "@lib/browser/FirefoxBrowser";
import {ChromeBrowser} from "@lib/browser/ChromeBrowser";
import {BrowserApi} from "@lib/browser/BrowserApi";

declare var chrome: { runtime?: {} };
declare var browser: unknown;

let context: {
  isInWebSiteContext: false;
  api: BrowserApi;
} | {
  isInWebSiteContext: true;
};

if (typeof browser !== "undefined" && Object.getPrototypeOf(browser) === Object.prototype) {
  context = {
    isInWebSiteContext: false,
    api: FirefoxBrowser
  }
}
else if (typeof chrome !== "undefined" && Object.getPrototypeOf(chrome) === Object.prototype) {
  context = {
    isInWebSiteContext: typeof chrome.runtime === "undefined",
    api: ChromeBrowser
  }
}
else {
  context = {
    isInWebSiteContext: true
  };
}


/**
 * Provides methods to store, retrieve, and remove logging configuration in context of the Web Extension or the website.
 */
export class LoggingConfigurationStorage {
  static async removeFromLoggingConfiguration(key: string): Promise<void> {
    if (context.isInWebSiteContext)
      localStorage.removeItem(key);
    else
      context.api.storage.local.remove(key);
  }

  static setLoggingConfiguration(key: string, value: string): void {
    if (context.isInWebSiteContext)
      localStorage.setItem(key, value);
    else
      context.api.storage.local.set({[key]: value});
  }

  static async getLoggingConfiguration(key: string): Promise<any> {
    if (context.isInWebSiteContext)
      return localStorage.getItem(key);
    else
      return await context.api.storage.local.get(key);
  }
}